module.exports = __webpack_public_path__ + "static/media/blind.a92dbfdd.svg";